const normalizeRuleValue = (value) =>
	String(value ?? '')
		.trim()
		.toUpperCase()

export const isOneByYMechanic = (mechanic) => {
	if (Number(mechanic) === 1) return true
	return normalizeRuleValue(mechanic).replace(/\s/g, '') === '1XY'
}

export const isJumboPrimeAdherenceException = ({
	retailer,
	activation,
	mechanic,
}) => {
	const normalizedRetailer = normalizeRuleValue(retailer)
	const isJumbo =
		normalizedRetailer === 'JUMBO' || normalizedRetailer === 'JUMBO.CL'

	return (
		isJumbo &&
		normalizeRuleValue(activation) === 'PRIME' &&
		isOneByYMechanic(mechanic)
	)
}
